module.exports = __webpack_public_path__ + "img/portada_conservas.2c33b82b.jpg";